<template>
  <el-dialog
    :visible="visible"
    @close="$emit('update:visible', false)"
    width="900px"
    :close-on-click-modal="false"
    custom-class="detail-data"
  >
    <div
      slot="title"
      class="Diatitle"
    >
      <span>{{ name }}</span>
    </div>
    <div class="detail-info">
      <div v-for="(item,index) in useParams(1)" :key="index" class="detail-info-item">
        <div class="label">
          {{ item.label }}
        </div>
        <div class="center">
          <el-popover
            v-if="['object','array'].includes(item.type)"
            placement="bottom"
            width="300"
            trigger="hover"
          >
            <div class="hover-content">
              <div v-if="item.type === 'object'">
                <p
                v-for="(val,valIndex) in item.children"
                :key="valIndex"
                >{{ val.label }}：{{ dataInfo[item.key] ? dataInfo[item.key][val.key] : '-' }}</p>
              </div>
              <div v-else>array</div>
            </div>
            <el-tag size="small" slot="reference" class="cursor">查看</el-tag>
          </el-popover>
          <p v-else class="overflow">{{ dataInfo[item.key] ?? '-' }}</p>
        </div>
      </div>
      <div class="detail-info-line"></div>
    </div>
    <div class="detail-info padding">
      <div v-for="(item) in useParams(2)" :key="item.key" class="detail-info-card">
        <div class="label">
          {{ item.label }}
        </div>
        <div v-if="item.type === 'object'" class="center">
          <el-tag v-for="val in item.children" :key="val.key" v-show="useShow(item.key,val.key)" type="danger">{{ val.label }}</el-tag>
          <!-- <div v-for="(val,valIndex) in item.children" :key="valIndex" class="card-item">
            <div class="card-item-label">
              {{ val.label }}
            </div>
            <div class="card-item-center">
              {{ dataInfo[item.key] ? dataInfo[item.key][val.key] : '-' }}
            </div>
          </div> -->
        </div>
        <div v-else>
          <el-table
            v-if="dataInfo[item.key]"
            height="150px"
            :data="dataInfo[item.key]"
            border
            stripe
            style="min-width: 100%"
            row-key="index"
            size="mini"
            ref="table">
            <el-table-column
              v-for="(val,valIndex) in item.children"
              :key="valIndex"
              :label="val.label"
              minWidth="100"
              :prop="val.key"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { historicalFailure, protectiveBoardData, jsonData2 } from '@/assets/js/registerType.js';
export default {
  name:'DetailData',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    terminalNo: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 1
    },
    refresh: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      dataInfo:{}
    };
  },
  watch:{
    visible:{
      handler(val){
        val && this.getData();
      },
      deep:true,
    },
    refresh:{
      handler(val){
        if(val){
          if(val?.num === 0 && this.visible){
            this.getData()
          }
        }
      },
      deep:true
    }
  },
  computed:{
    columnsData(){
      return this.type === 1 ? protectiveBoardData : historicalFailure;
    },
    name(){
      return this.type === 1 ? '保护板数据' : '历史故障信息';
    },
  },
  methods: {
    useShow(parentKey,key){
      if(this.dataInfo && this.dataInfo[parentKey]){
        return this.dataInfo[parentKey][key] === 1;
      }else{
        return false;
      }
    },
    useParams(type){
      if(type === 1){
        return this.columnsData.filter(item => !['object','array'].includes(item.type))
      }else{
        return this.columnsData.filter(item => ['object','array'].includes(item.type))
      }
    },
    // 获取数据
    async getData(){
      // const json = Object.keys(jsonData2).map(item => {
      //   const type = jsonData2[item] ? jsonData2[item].type : 'string';
      //   let children = null;
      //   if(type === 'array'){
      //     const childJson = jsonData2[item]?.items ? jsonData2[item].items.properties : [];
      //     children = Object.keys(childJson).map(val => ({ label:childJson[val].description, key:val }))
      //   }else if(type === 'object'){
      //     const childJson = jsonData2[item]?.properties ? jsonData2[item].properties : [];
      //     children = Object.keys(childJson).map(val => ({ label:childJson[val].description, key:val }))
      //   }
      //   return {
      //     label:jsonData2[item].description,
      //     key:item,
      //     type,
      //     children
      //   }
      // }).filter(item => item.type !== 'object' && item.type !== 'array');
      // console.log(jsonData2,json,'json')
      try{
        const url = this.type === 1 ? 'queryProtectiveBoardData' : 'queryHistoricalFaultInformation';
        const { data, code, msg } = await this.$API[url]({ terminalNo:this.terminalNo });
        if(code !== 0) throw { msg };
        this.dataInfo = data;
      }catch({ msg }) {
        this.$msg({
          type:'error',
          message:msg
        })
      }
    },

  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin.scss';
::v-deep .detail-data{
  z-index: 2010;
}
::v-deep .el-dialog__body {
  padding: 20px 0 20px !important;
}
::v-deep .el-dialog__headerbtn {
  top: 12px !important;
}
.padding{
  border-top: 2px solid #EBEEF5;
  margin-top: 20px;
}
.detail-info{
  @include scrollBar;
  max-height: 300px;
  overflow-y: auto;
  padding: 14px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-content: flex-start;
  &-item,.card-item{
    width: 50%;
    box-sizing: border-box;
    border: 1px solid #EBEEF5;
    border-bottom: none;
    >.label,.card-item-label{
      background: #fafafa;
      padding: 14px;
      border-bottom: 1px solid #EBEEF5;
    }
    >.center,.card-item-center{
      padding: 14px;
    }
  }
  .card-item{
    border-bottom: 1px solid #EBEEF5;
  }
  &-line{
    width: 100%;
    border-top: 1px solid #EBEEF5;
  }
  &-card{
    width: 100%;
    .label{
      font-size: 18px;
      font-family: 'PingFang SC';
      font-weight: bold;
      color: #000;
      margin: 14px 0;
    }
    .center{
      border: 1px solid #EBEEF5;
      padding: 14px;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      min-height:100px;
    }
  }
  .cursor{
    cursor: pointer;
  }
}
.Diatitle {
  width: 100%;
  height: 42px;
  background-color: #f6f6f6;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  span {
    padding: 0 20px;
    font-size: 18px;
    font-family: 'PingFang SC';
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
}
</style>
